import React, { useContext } from 'react'
import { Modal, Input, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { CloseOutlined } from '@ant-design/icons'

import { TicketNotifContext } from '@contexts'
import { NoteElement } from '@components'
import { useTicketsById } from '@hooks'
import { Note } from '@types'

import { StyledForm, StyledRow } from '../../../../../components/StyledComponents'

type Props = {
  open: boolean
  onClose: () => void
  onOk: (reason: { reason: string }, reset: () => void) => void
  loading: boolean
}

const { TextArea } = Input

const DeclineTicketModal: React.FC<Props> = ({ open, onClose, onOk, loading }) => {
  const { t } = useTranslation()
  const [form] = StyledForm.useForm()
  const { ticketById } = useTicketsById()
  const Ticket = useContext(TicketNotifContext)
  const reset = () => {
    form.resetFields()
    notification.destroy('validationError')
  }
  const proceed = () => {
    form
      .validateFields()
      .then(values => onOk({ reason: values.reason }, reset))
      .catch(() => {
        notification.destroy('validationError')
        notification.error({
          message: t('globals.validation_error'),
          key: 'validationError',
        })
      })
  }
  return (
    <Modal
      open={open}
      keyboard
      maskClosable
      onCancel={() => {
        form.resetFields()
        onClose()
      }}
      title={[t('tpl_router.tpl_dashboard.accept_decline_modal.decline.title'), ` ${Ticket.state}`]}
      okText={t('tpl_router.tpl_dashboard.accept_decline_modal.decline.button_ok')}
      cancelText={t('tpl_router.tpl_dashboard.accept_decline_modal.decline.button_cancel')}
      onOk={proceed}
      confirmLoading={loading}
      closeIcon={<CloseOutlined />}
    >
      <StyledForm form={form} initialValues={{}}>
        <StyledRow className="carrier-form-row">
          <StyledForm.Item
            label={t('tpl_router.tpl_dashboard.accept_decline_modal.decline.reason')}
            name="reason"
            rules={[{ required: true, message: t('globals.obligatory_field') }]}
          >
            <TextArea rows={3} />
          </StyledForm.Item>
        </StyledRow>
      </StyledForm>
      {ticketById?.ticket?.observations.map((observation: Note) => (
        <NoteElement data={observation} />
      ))}
    </Modal>
  )
}

export { DeclineTicketModal }
